<circle-progress
	[percent]="percentage"
	[radius]="20"
	[outerStrokeWidth]="2"
	[innerStrokeWidth]="0"
	[titleFontSize]="12"
	[showSubtitle]="false"
	[outerStrokeColor]="colorByPercentage"
	[animation]="true"
	[animationDuration]="300"
></circle-progress>
